import { createORPCClient } from "@orpc/client";
import type { ContractRouterClient } from "@orpc/contract";
import { OpenAPILink } from "@orpc/openapi-client/fetch";
import { createTanstackQueryUtils } from "@orpc/tanstack-query";
import { apiFetch } from "@packages/core-client/api/apiFetch.ts";
import { queryPath } from "@packages/core-client/query/queryKeys.ts";
import { useEnvironmentVariable } from "@squide/firefly";
import { useMemo } from "react";
import { scopeContract } from "#shared/scopeContract.ts";

function createTeamScopeClient(baseUrl: string) {
    const link = new OpenAPILink(scopeContract, {
        url: `${baseUrl}/api/team/scope`,
        fetch: apiFetch
    });

    const client: ContractRouterClient<typeof scopeContract> = createORPCClient(link);

    return createTanstackQueryUtils(client, { path: queryPath("team", ["members"]) });
}

export function useTeamScopeClient() {
    const apiBaseUrl = useEnvironmentVariable("apiBaseUrl");

    return useMemo(() => createTeamScopeClient(apiBaseUrl), [apiBaseUrl]);
}
